import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "aos/dist/aos.css";
ReactDOM.render(<App />, document.getElementById("root"));
